import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material.module';
import { ApiInterceptor } from './services/api.interceptor';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { AboutPageComponent } from './pages/about-page/about-page.component';
import { PageHeaderComponent } from './components/page/page-header/page-header.component';
import { PageFooterComponent } from './components/page/page-footer/page-footer.component';
import { UserAvatarMenuComponent } from './components/user-avatar-menu/user-avatar-menu.component';
import { HomeBannerComponent } from './components/home-banner/home-banner.component';
import { PlatformTabGroupComponent } from './components/platform/platform-tab-group/platform-tab-group.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { PageBottomComponent } from './components/page/page-bottom/page-bottom.component';
import { MainPageComponent } from './pages/main-page/main-page.component';
import { CommunityPageComponent } from './pages/community-page/community-page.component';
import { PlatformCardComponent } from './components/platform/platform-card/platform-card.component';
import { PlatformListComponent } from './components/platform/platform-list/platform-list.component';
import { ImageComponent } from './components/base/image/image.component';
import { PlatformTagComponent } from './components/platform/platform-tag/platform-tag.component';
import { PlatformCardPlaceholderComponent } from './components/platform/platform-card-placeholder/platform-card-placeholder.component';
import { CommunityComponent } from './components/community/community.component';
import { PlatformDialogComponent } from './components/platform/platform-dialog/platform-dialog.component';
import { PrivacyPageComponent } from './pages/privacy-page/privacy-page.component';
import { UserAgreementPageComponent } from './pages/user-agreement-page/user-agreement-page.component';
import { CustomerServiceDialogComponent } from './components/page/customer-service-dialog/customer-service-dialog.component';
import { OrderConfirmDialogComponent } from './components/order-confirm-dialog/order-confirm-dialog.component';
import { TrendingPageComponent } from './pages/trending-page/trending-page.component';
import { PageLoaderComponent } from './components/base/page-loader/page-loader.component';
import { MarketingArticleItemComponent } from './components/marketing-article-item/marketing-article-item.component';
import { MarketingArticlePageComponent } from './pages/marketing-article-page/marketing-article-page.component';
import { DateComponent } from './components/base/date/date.component';
import { PriceComponent } from './components/base/price/price.component';
import { UserProfilePageComponent } from './pages/profile/user-profile-page/user-profile-page.component';
import { UserProfileSeatsPageComponent } from './pages/profile/user-profile-seats-page/user-profile-seats-page.component';
import { UserProfileInfoPageComponent } from './pages/profile/user-profile-info-page/user-profile-info-page.component';
import { UserProfileAffiliatePageComponent } from './pages/profile/user-profile-affiliate-page/user-profile-affiliate-page.component';
import { BusSeatTicketComponent } from './components/profile/bus-seat-ticket/bus-seat-ticket.component';
import { PasswordComponent } from './components/base/password/password.component';
import { BusAccountInvitationLinkLabelComponent } from './components/profile/bus-account-invitation-link-label/bus-account-invitation-link-label.component';
import { DatetimeComponent } from './components/base/datetime/datetime.component';
import { BusSeatStatusComponent } from './components/profile/bus-seat-status/bus-seat-status.component';
import { BusPassengerDialogComponent } from './components/profile/bus-passenger-dialog/bus-passenger-dialog.component';
import { UserAvatarComponent } from './components/profile/user-avatar/user-avatar.component';
import { ConfirmDialogComponent } from './components/base/confirm-dialog/confirm-dialog.component';
import { QRCodeModule } from 'angularx-qrcode';
import { UserAffiliateShareCardComponent } from './components/profile/user-affiliate-share-card/user-affiliate-share-card.component';
import { UserAffiliateAvailableCommissionCardComponent } from './components/profile/user-affiliate-available-commission-card/user-affiliate-available-commission-card.component';
import { UserAffiliateFrozenCommissionCardComponent } from './components/profile/user-affiliate-frozen-commission-card/user-affiliate-frozen-commission-card.component';
import { UserAffiliateTotalCommissionCardComponent } from './components/profile/user-affiliate-total-commission-card/user-affiliate-total-commission-card.component';
import { UserAffiliateOrderPieCardComponent } from './components/profile/user-affiliate-order-pie-card/user-affiliate-order-pie-card.component';
import { UserAffiliateOrderLineCardComponent } from './components/profile/user-affiliate-order-line-card/user-affiliate-order-line-card.component';
import { UserAffiliateOrderListCardComponent } from './components/profile/user-affiliate-order-list-card/user-affiliate-order-list-card.component';
import { PlatformLabelComponent } from './components/platform/platform-label/platform-label.component';
import { UserAffiliateRatioDialogComponent } from './components/profile/user-affiliate-ratio-dialog/user-affiliate-ratio-dialog.component';
import { NgxImageCompressService } from 'ngx-image-compress';
import { ImageCropperDialogComponent } from './components/base/image-cropper-dialog/image-cropper-dialog.component';
import { GlobalLoadingComponent } from './components/base/global-loading/global-loading.component';
import { UpdateSelfNicknameDialogComponent } from './components/profile/update-self-nickname-dialog/update-self-nickname-dialog.component';
import { UpdateSelfPhoneDialogComponent } from './components/profile/update-self-phone-dialog/update-self-phone-dialog.component';
import { UpdateSelfPasswordDialogComponent } from './components/profile/update-self-password-dialog/update-self-password-dialog.component';
import { SmoothHeightComponent } from './components/base/smooth-height/smooth-height.component';
import { UserProfileAffiliateWithdrawalPageComponent } from './pages/profile/user-profile-affiliate-withdrawal-page/user-profile-affiliate-withdrawal-page.component';
import { BusinessContactDialogComponent } from './components/page/business-contact-dialog/business-contact-dialog.component';
import { ImageDialogComponent } from './components/base/image-dialog/image-dialog.component';
import { CouponDialogComponent } from './components/coupon-dialog/coupon-dialog.component';
import { UseFlowPageComponent } from './pages/yun-login/use-flow-page/use-flow-page.component';
import { AigcStepComponent } from './components/yun-login/aigc-step/aigc-step.component';
import { GetCodeStepModalComponent } from './components/profile/get-code-step-modal/get-code-step-modal.component';
import { TipPlatformVerificationCodeModalComponent } from './components/profile/tip-platform-verification-code-modal/tip-platform-verification-code-modal.component';
import { RefreshPlatformVerificationCodeModalComponent } from './components/profile/refresh-platform-verification-code-modal/refresh-platform-verification-code-modal.component';
import { VerificationCodePanelComponent } from './components/profile/verification-code-panel/verification-code-panel.component';
import { VerificationCodeComponent } from './components/profile/verification-code/verification-code.component';
import { UserProfileFormPageComponent } from './pages/profile/user-profile-form-page/user-profile-form-page.component';
import { InputComponent } from './components/base/input/input.component';
import { SelectComponent } from './components/base/select/select.component';
import { SexRadioButtonComponent } from './components/base/sex-radio-button/sex-radio-button.component';
import { UserAffiliateCreateCouponComponent } from './components/profile/user-affiliate-create-coupon/user-affiliate-create-coupon.component';
import { CouponListModalComponent } from './components/profile/coupon-list-modal/coupon-list-modal.component';
import { DaysCountdownComponent } from './components/base/days-countdown/days-countdown.component';
import { AffiliateModalComponent } from './components/profile/affiliate-modal/affiliate-modal.component';
import { HelpingPageComponent } from './pages/helping/helping-page/helping-page.component';
import { HelpingDetailPageComponent } from './pages/helping/helping-detail-page/helping-detail-page.component';
import { HelpingTotalPageComponent } from './pages/helping/helping-total-page/helping-total-page.component';
import { HelpingDetailArticlePageComponent } from './pages/helping/helping-detail-article-page/helping-detail-article-page.component';
import { UserProfileFleetPageComponent } from './pages/profile/user-profile-fleet-page/user-profile-fleet-page.component';
import { FleetCardComponent } from './components/profile/fleet-card/fleet-card.component';
import { FleetNodeModalComponent } from './components/profile/fleet-node-modal/fleet-node-modal.component';
import { FleetTipModalComponent } from './components/profile/fleet-tip-modal/fleet-tip-modal.component';
import { FleetCardLoaderComponent } from './components/profile/fleet-card-loader/fleet-card-loader.component';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { UserProfileFleetHistoryBoardPageComponent } from './pages/profile/user-profile-fleet-history-board-page/user-profile-fleet-history-board-page.component';
import { TipModalComponent } from './components/tip-modal/tip-modal.component';
import { AdobePanelComponent } from './components/profile/adobe-panel/adobe-panel.component';
import { AdobeModalComponent } from './components/profile/adobe-modal/adobe-modal.component';
import { AdobeTipModalComponent } from './components/profile/adobe-tip-modal/adobe-tip-modal.component';
import { PopcornLandingPageComponent } from './pages/popcorn/popcorn-landing-page/popcorn-landing-page.component';
import { ExchangeCodeComponent } from './components/base/exchange-code/exchange-code.component';
import { PopcornAfterPageComponent } from './pages/popcorn/popcorn-after-page/popcorn-after-page.component';
import { PopcornBeforePageComponent } from './pages/popcorn/popcorn-before-page/popcorn-before-page.component';
import { CooperatePageComponent } from './pages/cooperate-page/cooperate-page.component';
import { MidjourneyComponent } from './pages/midjourney/midjourney.component';
import { MidjourneyDialogComponent } from './components/midjourney/midjourney-dialog/midjourney-dialog.component';

import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzBadgeModule } from 'ng-zorro-antd/badge';

import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { zh_CN } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import zh from '@angular/common/locales/zh';
registerLocaleData(zh);
import { BusinessPageComponent } from './pages/business-page/business-page.component';
import { SalesIntroductionPageComponent } from './pages/sales-introduction-page/sales-introduction-page.component';
import { BusSeatWorkorderPanelComponent } from './components/profile/bus-seat-workorder-panel/bus-seat-workorder-panel.component';
import { WorkorderAfterSales1ModalComponent } from './components/profile/workorder-after-sales1-modal/workorder-after-sales1-modal.component';
import { WorkorderAfterSales2ModalComponent } from './components/profile/workorder-after-sales2-modal/workorder-after-sales2-modal.component';
import { WorkorderAfterSales4ModalComponent } from './components/profile/workorder-after-sales4-modal/workorder-after-sales4-modal.component';
import { ImageUploaderQiniuComponent } from './components/base/image-uploader-qiniu/image-uploader-qiniu.component';
import { WorkorderAfterSales3ModalComponent } from './components/profile/workorder-after-sales3-modal/workorder-after-sales3-modal.component';
import { UserProfileWorkorderPageComponent } from './pages/profile/user-profile-workorder-page/user-profile-workorder-page.component';
import { WorkorderCardSearchComponent } from './components/profile/workorder/workorder-card-search/workorder-card-search.component';
import { WorkorderCardComponent } from './components/profile/workorder/workorder-card/workorder-card.component';
import { InitWorkorderPanelComponent } from './components/profile/workorder/init-workorder-panel/init-workorder-panel.component';
import { CreateWorkorderPanelComponent } from './components/profile/workorder/create-workorder-panel/create-workorder-panel.component';
import { SubscriptionSelectComponent } from './components/profile/workorder/subscription-select/subscription-select.component';
import { IssueCategory2SelectComponent } from './components/profile/workorder/issue-category2-select/issue-category2-select.component';
import { IssueCategorySelectComponent } from './components/profile/workorder/issue-category-select/issue-category-select.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { CkeditorComponent } from './components/base/ckeditor/ckeditor.component';
import { WorkorderDetailCardComponent } from './components/profile/workorder/workorder-detail-card/workorder-detail-card.component';
import { NzAnchorModule } from 'ng-zorro-antd/anchor';
import { PlatformTabListComponent } from './components/platform/platform-tab-list/platform-tab-list.component';
import { PlatformSearchComponent } from './components/platform/platform-search/platform-search.component';
import { WishBoardComponent } from './components/platform/wish-board/wish-board.component';
import { ProductAnchorComponent } from './components/platform/product-anchor/product-anchor.component';
import { WxloginModalComponent } from './components/wxlogin-modal/wxlogin-modal.component';
import { PreventingFraudModalComponent } from './components/preventing-fraud-modal/preventing-fraud-modal.component';
import { ChooseCompensateNetflixModalComponent } from './components/compensate/choose-compensate-netflix-modal/choose-compensate-netflix-modal.component';
import { ChangePopcornModalComponent } from './components/compensate/change-popcorn-modal/change-popcorn-modal.component';
import { ImageCheckerComponent } from './components/login/image-checker/image-checker.component';
import { GocaptchaComponent } from './components/login/gocaptcha/gocaptcha.component';
import { OverseasPhoneDialogComponent } from './components/login/overseas-phone-dialog/overseas-phone-dialog.component';
import { YoutubeTipModalComponent } from './components/youtube-tip-modal/youtube-tip-modal.component';
import { PlatformDialogTestComponent } from './components/platform/platform-dialog-test/platform-dialog-test.component';
import { OrderConfirmDialogTestComponent } from './components/order-confirm-dialog-test/order-confirm-dialog-test.component';
import { ChangeJiegehaoModalComponent } from './components/compensate/change-jiegehao-modal/change-jiegehao-modal.component';
import { GotoModalComponent } from './components/page/goto-modal/goto-modal.component';
import { StartReviewPanelComponent } from './components/profile/workorder/start-review-panel/start-review-panel.component';
import { EvaluateModalComponent } from './components/profile/workorder/evaluate-modal/evaluate-modal.component';
import { EvaluateAfterModalComponent } from './components/profile/workorder/evaluate-after-modal/evaluate-after-modal.component';
import { InputPanelComponent } from './components/profile/workorder/input-panel/input-panel.component';
import { ChoiceProcessModalComponent } from './components/presales-aftersales/choice-process-modal/choice-process-modal.component';
import { PreSales1ModalComponent } from './components/presales-aftersales/pre-sales1-modal/pre-sales1-modal.component';
import { PreSales2ModalComponent } from './components/presales-aftersales/pre-sales2-modal/pre-sales2-modal.component';
import { PlatformTabListSversionComponent } from './components/presales-aftersales/platform-tab-list-sversion/platform-tab-list-sversion.component';
import { AfterSales1ModalComponent } from './components/presales-aftersales/after-sales1-modal/after-sales1-modal.component';
import { AfterSales2ModalComponent } from './components/presales-aftersales/after-sales2-modal/after-sales2-modal.component';
import { WechatOfficialAccountModalComponent } from './components/wechat-official-account-modal/wechat-official-account-modal.component';
import { PlatformSelectionModalComponent } from './components/platform/platform-selection-modal/platform-selection-modal.component';
import { RefundWalletModalComponent } from './components/compensate/refund-wallet-modal/refund-wallet-modal.component';
import { RefundWalletYoutubeModalComponent } from './components/compensate/refund-wallet-youtube-modal/refund-wallet-youtube-modal.component';
import { ChooseCompensateYoutubeModalComponent } from './components/compensate/choose-compensate-youtube-modal/choose-compensate-youtube-modal.component';
import { RepairFailModalComponent } from './components/compensate/repair-fail-modal/repair-fail-modal.component';
import { EnterEmailModalComponent } from './components/compensate/enter-email-modal/enter-email-modal.component';
import { RepairAwaitingModalComponent } from './components/compensate/repair-awaiting-modal/repair-awaiting-modal.component';
import { BusSeatStatusRepairComponent } from './components/profile/bus-seat-status-repair/bus-seat-status-repair.component';
import { RepairTimeLabelComponent } from './components/compensate/repair-time-label/repair-time-label.component';
import { PreYoutubeModalComponent } from './components/platform/pre-purchase-notice/pre-youtube-modal/pre-youtube-modal.component';
import { PreYoutubeThreeMonthModalComponent } from './components/platform/pre-purchase-notice/pre-youtube-three-month-modal/pre-youtube-three-month-modal.component';
import { FreezeModalComponent } from './components/compensate/freeze-modal/freeze-modal.component';
import { ActivityModalComponent } from './components/discount/activity-modal/activity-modal.component';
import { YoutubeRechargePanelComponent } from './components/profile/youtube-recharge-panel/youtube-recharge-panel.component';
import { AccountComponent } from './components/base/account/account.component';
import { AdobeTeamModalComponent } from './components/profile/adobe-team-modal/adobe-team-modal.component';
import { GeminiTipModalComponent } from './components/profile/gemini-tip-modal/gemini-tip-modal.component';
import { HolidayNoticeModalComponent } from './components/holiday-notice-modal/holiday-notice-modal.component';
import { SpecialWorkorderPanelComponent } from './components/profile/workorder/special-part/special-workorder-panel/special-workorder-panel.component';
import { SpecialQuestionPanelComponent } from './components/profile/workorder/special-part/special-question-panel/special-question-panel.component';
import { BeforeWorkorderModal2Component } from './components/profile/workorder/special-part/before-workorder-modal2/before-workorder-modal2.component';
import { PreNetflixModalComponent } from './components/platform/pre-purchase-notice/pre-netflix-modal/pre-netflix-modal.component';
import { ChangeAccountErrorModalComponent } from './components/profile/change-account-error-modal/change-account-error-modal.component';
import { SelectedPageComponent } from './pages/selected-page/selected-page.component';
import { ShowedModalComponent } from './components/selected/showed-modal/showed-modal.component';
import { RankingModalComponent } from './components/selected/ranking-modal/ranking-modal.component';
import { SwiperModule } from 'swiper/angular';
import { HomeCarouselComponent } from './components/page/home-carousel/home-carousel.component';
import { HelpAnchorComponent } from './components/help/help-anchor/help-anchor.component';
import { BusSeatSearchComponent } from './components/profile/bus-seat-search/bus-seat-search.component';
import { UserAffiliateInfoPanelComponent } from './components/profile/user-affiliate-info-panel/user-affiliate-info-panel.component';
import { UserAffiliateInfoModalComponent } from './components/profile/user-affiliate-info-modal/user-affiliate-info-modal.component';
import { UserProfileFleetGrokPageComponent } from './pages/profile/user-profile-fleet-grok-page/user-profile-fleet-grok-page.component';
import { FleetCardGrokComponent } from './components/profile/fleet-card-grok/fleet-card-grok.component';
import { StartReviewTotalPanelComponent } from './components/profile/workorder/start-review-total-panel/start-review-total-panel.component';
import { WorkorderTipComponent } from './components/profile/workorder/workorder-tip/workorder-tip.component';
import { WorkorderProgressPanelComponent } from './components/profile/workorder/workorder-progress-panel/workorder-progress-panel.component';
import { ChooseCompensateAdobeModalComponent } from './components/compensate/choose-compensate-adobe-modal/choose-compensate-adobe-modal.component';
import { RefundWalletAdobeModalComponent } from './components/compensate/refund-wallet-adobe-modal/refund-wallet-adobe-modal.component';
import { FirstPasswordModalComponent } from './components/first-password-modal/first-password-modal.component';
import { VerificationCodeNewComponent } from './components/profile/verification-code-new/verification-code-new.component';
import { UserOrderStatusComponent } from './components/profile/order/user-order-status/user-order-status.component';
import { UserProfileOrderPageComponent } from './pages/profile/user-profile-order-page/user-profile-order-page.component';
import { UserProfileOrderRefundPageComponent } from './pages/profile/user-profile-order-refund-page/user-profile-order-refund-page.component';
import { OrderCardComponent } from './components/profile/order/order-card/order-card.component';
import { OpenBillInfoModalComponent } from './components/profile/order/open-bill-info-modal/open-bill-info-modal.component';
import { OpenRefundPanelComponent } from './components/profile/order/open-refund-panel/open-refund-panel.component';
import { UserProfileSupportPageComponent } from './pages/profile/user-profile-support-page/user-profile-support-page.component';
import { Support1PanelComponent } from './components/profile/support/support1-panel/support1-panel.component';
import { Support2PanelComponent } from './components/profile/support/support2-panel/support2-panel.component';
import { Support3PanelComponent } from './components/profile/support/support3-panel/support3-panel.component';
import { Support4PanelComponent } from './components/profile/support/support4-panel/support4-panel.component';
import { SupportsDialogComponent } from './components/profile/support/supports-dialog/supports-dialog.component';
import { SupportProgressDialogComponent } from './components/profile/support/support-progress-dialog/support-progress-dialog.component';
import { HelpModalComponent } from './components/profile/support/help-modal/help-modal.component';
import { AccountSupportModalComponent } from './components/profile/support/account-support-modal/account-support-modal.component';
import { SupportGuideComponent } from './components/profile/support/support-guide/support-guide.component';

@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    AboutPageComponent,
    PageHeaderComponent,
    PageFooterComponent,
    UserAvatarMenuComponent,
    HomeBannerComponent,
    PlatformTabGroupComponent,
    LoginPageComponent,
    PageBottomComponent,
    MainPageComponent,
    CommunityPageComponent,
    PlatformCardComponent,
    PlatformListComponent,
    ImageComponent,
    PlatformTagComponent,
    PlatformCardPlaceholderComponent,
    CommunityComponent,
    PlatformDialogComponent,
    PrivacyPageComponent,
    UserAgreementPageComponent,
    CustomerServiceDialogComponent,
    OrderConfirmDialogComponent,
    TrendingPageComponent,
    PageLoaderComponent,
    MarketingArticleItemComponent,
    MarketingArticlePageComponent,
    DateComponent,
    PriceComponent,
    UserProfilePageComponent,
    UserProfileSeatsPageComponent,
    UserProfileInfoPageComponent,
    UserProfileAffiliatePageComponent,
    BusSeatTicketComponent,
    PasswordComponent,
    BusAccountInvitationLinkLabelComponent,
    DatetimeComponent,
    BusSeatStatusComponent,
    BusPassengerDialogComponent,
    UserAvatarComponent,
    ConfirmDialogComponent,
    UserAffiliateShareCardComponent,
    UserAffiliateAvailableCommissionCardComponent,
    UserAffiliateFrozenCommissionCardComponent,
    UserAffiliateTotalCommissionCardComponent,
    UserAffiliateOrderPieCardComponent,
    UserAffiliateOrderLineCardComponent,
    UserAffiliateOrderListCardComponent,
    PlatformLabelComponent,
    UserAffiliateRatioDialogComponent,
    ImageCropperDialogComponent,
    GlobalLoadingComponent,
    UpdateSelfNicknameDialogComponent,
    UpdateSelfPhoneDialogComponent,
    UpdateSelfPasswordDialogComponent,
    SmoothHeightComponent,
    UserProfileAffiliateWithdrawalPageComponent,
    BusinessContactDialogComponent,
    ImageDialogComponent,
    CouponDialogComponent,
    UseFlowPageComponent,
    AigcStepComponent,
    GetCodeStepModalComponent,
    TipPlatformVerificationCodeModalComponent,
    RefreshPlatformVerificationCodeModalComponent,
    VerificationCodePanelComponent,
    VerificationCodeComponent,
    UserProfileFormPageComponent,
    InputComponent,
    SelectComponent,
    SexRadioButtonComponent,
    UserAffiliateCreateCouponComponent,
    CouponListModalComponent,
    DaysCountdownComponent,
    AffiliateModalComponent,
    HelpingPageComponent,
    HelpingDetailPageComponent,
    HelpingTotalPageComponent,
    HelpingDetailArticlePageComponent,
    UserProfileFleetPageComponent,
    FleetCardComponent,
    FleetNodeModalComponent,
    FleetTipModalComponent,
    FleetCardLoaderComponent,
    UserProfileFleetHistoryBoardPageComponent,
    TipModalComponent,
    AdobePanelComponent,
    AdobeModalComponent,
    AdobeTipModalComponent,
    PopcornLandingPageComponent,
    ExchangeCodeComponent,
    PopcornAfterPageComponent,
    PopcornBeforePageComponent,
    CooperatePageComponent,
    MidjourneyComponent,
    MidjourneyDialogComponent,
    BusinessPageComponent,
    SalesIntroductionPageComponent,
    BusSeatWorkorderPanelComponent,
    WorkorderAfterSales1ModalComponent,
    WorkorderAfterSales2ModalComponent,
    WorkorderAfterSales4ModalComponent,
    ImageUploaderQiniuComponent,
    WorkorderAfterSales3ModalComponent,
    UserProfileWorkorderPageComponent,
    WorkorderCardSearchComponent,
    WorkorderCardComponent,
    InitWorkorderPanelComponent,
    CreateWorkorderPanelComponent,
    SubscriptionSelectComponent,
    IssueCategory2SelectComponent,
    IssueCategorySelectComponent,
    CkeditorComponent,
    WorkorderDetailCardComponent,
    ProductAnchorComponent,
    PlatformTabListComponent,
    PlatformSearchComponent,
    WishBoardComponent,
    WxloginModalComponent,
    PreventingFraudModalComponent,
    ChooseCompensateNetflixModalComponent,
    ChangePopcornModalComponent,
    GocaptchaComponent,
    OverseasPhoneDialogComponent,
    ImageCheckerComponent,
    YoutubeTipModalComponent,
    PlatformDialogTestComponent,
    OrderConfirmDialogTestComponent,
    ChangeJiegehaoModalComponent,
    GotoModalComponent,
    StartReviewPanelComponent,
    EvaluateModalComponent,
    EvaluateAfterModalComponent,
    InputPanelComponent,
    ChoiceProcessModalComponent,
    PreSales1ModalComponent,
    PreSales2ModalComponent,
    PlatformTabListSversionComponent,
    AfterSales1ModalComponent,
    AfterSales2ModalComponent,
    WechatOfficialAccountModalComponent,
    PlatformSelectionModalComponent,
    RefundWalletModalComponent,
    RefundWalletYoutubeModalComponent,
    ChooseCompensateYoutubeModalComponent,
    RepairFailModalComponent,
    EnterEmailModalComponent,
    RepairAwaitingModalComponent,
    BusSeatStatusRepairComponent,
    RepairTimeLabelComponent,
    PreYoutubeModalComponent,
    PreYoutubeThreeMonthModalComponent,
    FreezeModalComponent,
    ActivityModalComponent,
    YoutubeRechargePanelComponent,
    AccountComponent,
    AdobeTeamModalComponent,
    GeminiTipModalComponent,
    HolidayNoticeModalComponent,
    SpecialWorkorderPanelComponent,
    SpecialQuestionPanelComponent,
    BeforeWorkorderModal2Component,
    PreNetflixModalComponent,
    ChangeAccountErrorModalComponent,
    SelectedPageComponent,
    ShowedModalComponent,
    RankingModalComponent,
    HomeCarouselComponent,
    HelpAnchorComponent,
    BusSeatSearchComponent,
    UserAffiliateInfoPanelComponent,
    UserAffiliateInfoModalComponent,
    UserProfileFleetGrokPageComponent,
    FleetCardGrokComponent,
    StartReviewTotalPanelComponent,
    WorkorderTipComponent,
    WorkorderProgressPanelComponent,
    ChooseCompensateAdobeModalComponent,
    RefundWalletAdobeModalComponent,
    FirstPasswordModalComponent,
    VerificationCodeNewComponent,
    UserOrderStatusComponent,
    UserProfileOrderPageComponent,
    UserProfileOrderRefundPageComponent,
    OrderCardComponent,
    OpenBillInfoModalComponent,
    OpenRefundPanelComponent,
    UserProfileSupportPageComponent,
    Support1PanelComponent,
    Support2PanelComponent,
    Support3PanelComponent,
    Support4PanelComponent,
    SupportsDialogComponent,
    SupportProgressDialogComponent,
    HelpModalComponent,
    AccountSupportModalComponent,
    SupportGuideComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    QRCodeModule,
    NzProgressModule,
    NzLayoutModule,
    NzButtonModule,
    NzIconModule,
    NzGridModule,
    NzInputModule,
    NzAvatarModule,
    NzImageModule,
    NzUploadModule,
    NzPopoverModule,
    NzAnchorModule,
    CKEditorModule,
    // SwiperModule,
    NzBadgeModule,
    SwiperModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
    NgxImageCompressService,
    { provide: NZ_I18N, useValue: zh_CN },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
